<template>
  <!-- <div v-if="showForm"> -->
  <div>
    <div id="overlay" @click="$emit('close-form')"></div>
    <div id="form">
      <div v-if="!showForm">
        <spinner />
      </div>
      <div v-else>
        <div class="row details-area">
          <b-form class="col-xs-12">
            <div class="header-form">
              <div v-if="formType == 'edit'">Editar setor {{ oldName }}</div>
              <div v-else>Adicionar setor</div>
            </div>
            <div class="col-xs-12">
              <!-- Seção 1: campos básicos, sem divider -->
              <b-form-text id="sectorNameInputLiveHelp"> Nome * </b-form-text>
              <b-form-input
                v-model.trim="form.NAME"
                placeholder="Nome"
                aria-describedby="sectorNameInputLiveHelp sectorNameInputLiveFeedback"
                :state="nameState && notRepeatedName"
                maxlength="24"
                id="sectorNameInput"
                size="sm"
              />
              <div class="field-feedback">
                <span v-if="!nameState">Campo inválido</span>
                <span v-else-if="!notRepeatedName">Esse nome já está em uso</span>
              </div>

              <b-form-text id="sectorAreaInputLiveHelp"> Área * </b-form-text>
              <b-form-input
                v-model="form.AREA"
                placeholder="Área"
                aria-describedby="sectorAreaInputLiveHelp sectorAreaInputLiveFeedback"
                :state="areaState"
                maxlength="24"
                id="sectorAreaInput"
                size="sm"
              />
              <div class="field-feedback">
                <span v-if="!areaState">Campo inválido (casas decimais pós ponto)</span>
              </div>

              <b-form-text id="sectorTypeInputLiveHelp">
                Fruto cultivado
              </b-form-text>

              <!-- É setor de manejo -->
              <template v-if="managementForm && managementForm.IS_MANAGEMENT">
                <searchable-select
                  v-model="managementForm.ID_FARM"
                  :options="managementFarms"
                  text-field="NAME"
                  value-field="ID"
                  :state="farmState ? null : false"
                  :clearable="false"
                  placeholder="Selecione o cultivar *"
                  @change="onFarmSelect"
                />
              </template>
              <b-form-input
                v-else
                v-model="form.PLANTING_TYPE"
                placeholder="Fruto cultivado"
                aria-describedby="sectorTypeInputLiveHelp sectorTypeInputLiveFeedback"
                :state="true"
                maxlength="24"
                size="sm"
                id="sectorTypeInput"
              />
              <div class="field-feedback">
                <span v-if="!farmState">É necessário escolher um cultivar</span>
              </div>

              <!-- Solo: sempre visível, obrigatório apenas se IS_MANAGEMENT -->
              <b-form-text>{{ managementForm.IS_MANAGEMENT ? 'Solo *' : 'Solo' }}</b-form-text>
              <searchable-select
                v-model="managementForm.ID_SOIL"
                :options="managementSoil"
                text-field="NAME"
                value-field="ID"
                :state="soilState ? null : false"
                :clearable="false"
                placeholder="Selecione o solo"
                @change="onSoilSelect"
              />
              <div class="field-feedback">
                <span v-if="!soilState">É necessário escolher um solo</span>
              </div>

              <b-form-checkbox
                v-if="hasAccess"
                size="sm"
                v-model="managementForm.IS_MANAGEMENT"
                switch
                class="my-3"
              >
                Realizar manejo de irrigação no setor?
              </b-form-checkbox>
              <div v-if="!hasAccess">
                <b-form-text id="sectorDateInputLiveHelp">
                  Data de plantio
                </b-form-text>
                <b-form-input
                  v-model="form.PLANTING_DATE"
                  type="date"
                  :state="true"
                  size="sm"
                  aria-describedby="sectorDateInputLiveHelp"
                  id="sectorDateInput"
                />
              </div>

              <!-- Seções de manejo -->
              <template v-if="managementForm.IS_MANAGEMENT">
                <!-- Seção: Aspectos Físicos -->
                <div class="group-inputs-title">Aspectos Físicos:</div>

                <b-form-text id="sectorLinesInputLiveHelp">Espaçamento entre Linhas (m) *</b-form-text>
                <b-form-input
                  v-model="managementForm.SPACING_BETWEEN_LINES"
                  type="text"
                  inputmode="decimal"
                  :state="spaceBetweensLinesState"
                  size="sm"
                  aria-describedby="sectorLinesInputLiveHelp"
                />
                <div class="field-feedback">
                  <span v-if="hasDecimalComma(managementForm.SPACING_BETWEEN_LINES)">Use ponto (.) como separador decimal, não vírgula.</span>
                  <span v-else-if="!spaceBetweensLinesState">Obrigatório: valor maior que 0.</span>
                </div>

                <b-form-text id="sectorPlantsInputLiveHelp">Espaçamento entre Plantas (m) *</b-form-text>
                <b-form-input
                  v-model="managementForm.SPACING_BETWEEN_PLANTS"
                  type="text"
                  inputmode="decimal"
                  :state="spaceBetweensPlantsState"
                  size="sm"
                  aria-describedby="sectorPlantsInputLiveHelp"
                />
                <div class="field-feedback">
                  <span v-if="hasDecimalComma(managementForm.SPACING_BETWEEN_PLANTS)">Use ponto (.) como separador decimal, não vírgula.</span>
                  <span v-else-if="!spaceBetweensPlantsState">Obrigatório: valor maior que 0.</span>
                </div>

                <!-- Seção: Dados Hidráulicos -->
                <div class="group-inputs-title">Dados Hidráulicos:</div>

                <b-form-text id="sectorAppRateInputLiveHelp">Taxa de aplicação de projeto (mm/h) *</b-form-text>
                <b-form-input
                  v-model="managementForm.APPLICATION_RATE"
                  type="text"
                  inputmode="decimal"
                  :state="applicationRateState"
                  size="sm"
                  aria-describedby="sectorAppRateInputLiveHelp"
                />
                <div class="field-feedback">
                  <span v-if="hasDecimalComma(managementForm.APPLICATION_RATE)">Use ponto (.) como separador decimal, não vírgula.</span>
                  <span v-else-if="!applicationRateState">Obrigatório: valor maior que 0.</span>
                </div>

                <b-form-text id="sectorEfficiencyInputLiveHelp">Eficiência do Sistema (%) *</b-form-text>
                <b-form-input
                  v-model="managementForm.SYSTEM_EFFICIENCY"
                  type="text"
                  inputmode="decimal"
                  :state="systemEfficiencyState"
                  size="sm"
                  aria-describedby="sectorEfficiencyInputLiveHelp"
                />
                <div class="field-feedback">
                  <span v-if="hasDecimalComma(managementForm.SYSTEM_EFFICIENCY)">Use ponto (.) como separador decimal, não vírgula.</span>
                  <span v-else-if="!systemEfficiencyState">Obrigatório: valor entre 1 e 100.</span>
                </div>

                <!-- Seção: Aspectos Temporais -->
                <div class="group-inputs-title">Aspectos Temporais:</div>

                <b-form-text id="sectorVolumeDateInputLiveHelp">Data inicial de manejo *</b-form-text>
                <b-form-input
                  v-model="managementForm.VOLUME_DATE"
                  type="date"
                  size="sm"
                  aria-describedby="sectorVolumeDateInputLiveHelp"
                  id="sectorVolumeDateInput"
                  lazy-formatter
                  :state="validManagementDate"
                />
                <div class="field-feedback">
                  <span v-if="!validManagementDate">Insira uma data inicial de manejo válida.</span>
                </div>

                <b-form-text id="sectorPlantingDateInputLiveHelp">Data de plantio *</b-form-text>
                <b-form-input
                  v-model="form.PLANTING_DATE"
                  type="date"
                  size="sm"
                  :state="plantingDateState"
                  aria-describedby="sectorPlantingDateInputLiveHelp"
                />
                <div class="field-feedback">
                  <span v-if="!plantingDateState">Insira uma data de plantio válida.</span>
                </div>

                <b-form-text id="sectorCropDateInputLiveHelp">Data de colheita</b-form-text>
                <b-form-input
                  v-model="managementForm.DATE_CROP"
                  type="date"
                  :state="dateCropState ? null : false"
                  size="sm"
                  debounce="500"
                  aria-describedby="sectorCropDateInputLiveHelp"
                />
                <div class="field-feedback">
                  <span v-if="!dateCropState">Deve ser posterior ao plantio e ao início do manejo.</span>
                </div>

                <b-form-text id="sectorStorageInputLiveHelp" class="mt-3">Armazenamento Inicial (mm)</b-form-text>
                <b-form-input
                  v-model="managementForm.INITIAL_STORAGE"
                  type="text"
                  inputmode="decimal"
                  placeholder="Armazenamento inicial"
                  aria-describedby="sectorStorageInputLiveHelp sectorStorageInputLiveFeedback"
                  :state="initialStorageState"
                  maxlength="24"
                  id="sectorStorageInput"
                  size="sm"
                />
                <div class="field-feedback">
                  <span v-if="hasDecimalComma(managementForm.INITIAL_STORAGE)">Use ponto (.) como separador decimal, não vírgula.</span>
                  <span v-else-if="initialStorageState === false">Máximo permitido: {{ managementForm.MAX_STORAGE }} mm.</span>
                </div>
                <div
                  v-if="form.PLANTING_DATE && managementForm.MAX_STORAGE >= 0"
                  class="max-storage-feedback mb-3"
                >
                  Armazenamento máximo: {{ managementForm.MAX_STORAGE }} mm
                </div>

                <!-- Seção: Configuração de aproveitamento de precipitação -->
                <div class="group-inputs-title">Configuração de aproveitamento de precipitação:</div>

                <div class="mb-2 d-flex" style="gap: 0.5rem">
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="rainThresholdCount >= 2"
                    @click="addRainThreshold"
                  >Adicionar limiar</b-button>
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    :disabled="rainThresholdCount < 1"
                    @click="removeRainThreshold(rainThresholdCount)"
                  >Remover limiar</b-button>
                </div>

                <b-form-text class="mt-2">
                  <span v-if="rainThresholdCount === 0">Precipitação efetiva (toda chuva) (%)</span>
                  <span v-else>Precipitação efetiva de 0 a {{ managementForm.RAIN_THRESHOLD_1 || 0 }} mm (%)</span>
                </b-form-text>
                <b-form-input
                  v-model="managementForm.RAIN_FACTOR_1"
                  type="text"
                  inputmode="decimal"
                  size="sm"
                  :state="rainFactor1State"
                />
                <div class="field-feedback">
                  <span v-if="hasDecimalComma(managementForm.RAIN_FACTOR_1)">Use ponto (.) como separador decimal, não vírgula.</span>
                  <span v-else-if="!rainFactor1State">Obrigatório: valor entre 0 e 100.</span>
                </div>

                <template v-if="rainThresholdCount >= 1">
                  <b-form-text class="mt-2">Primeiro limiar de precipitação (mm)</b-form-text>
                  <b-form-input
                    v-model="managementForm.RAIN_THRESHOLD_1"
                    type="text"
                    inputmode="decimal"
                    size="sm"
                    :state="rainThreshold1State"
                  />
                  <div class="field-feedback">
                    <span v-if="hasDecimalComma(managementForm.RAIN_THRESHOLD_1)">Use ponto (.) como separador decimal, não vírgula.</span>
                    <span v-else-if="rainThreshold1State === false">O limiar deve ser maior que 0.</span>
                  </div>

                  <template v-if="rainThresholdCount >= 2">
                    <b-form-text class="mt-2">
                      Precipitação efetiva de {{ managementForm.RAIN_THRESHOLD_1 || 0 }} a {{ managementForm.RAIN_THRESHOLD_2 || 0 }} mm (%)
                    </b-form-text>
                    <b-form-input
                      v-model="managementForm.RAIN_FACTOR_2"
                      type="text"
                      inputmode="decimal"
                      size="sm"
                      :state="rainFactor2State"
                    />
                    <div class="field-feedback">
                      <span v-if="hasDecimalComma(managementForm.RAIN_FACTOR_2)">Use ponto (.) como separador decimal, não vírgula.</span>
                      <span v-else-if="rainFactor2State === false">Obrigatório: valor entre 0 e 100.</span>
                    </div>

                    <b-form-text class="mt-2">Segundo limiar de precipitação (mm)</b-form-text>
                    <b-form-input
                      v-model="managementForm.RAIN_THRESHOLD_2"
                      type="text"
                      inputmode="decimal"
                      size="sm"
                      :state="rainThreshold2State"
                    />
                    <div class="field-feedback">
                      <span v-if="hasDecimalComma(managementForm.RAIN_THRESHOLD_2)">Use ponto (.) como separador decimal, não vírgula.</span>
                      <span v-else-if="rainThreshold2State === false">Segundo limiar deve ser maior que o primeiro.</span>
                    </div>
                  </template>

                  <b-form-text class="mt-2">
                    Precipitação efetiva acima de {{ rainThresholdCount >= 2 ? (managementForm.RAIN_THRESHOLD_2 || 0) : (managementForm.RAIN_THRESHOLD_1 || 0) }} mm (%)
                  </b-form-text>
                  <b-form-input
                    v-model="managementForm.RAIN_FACTOR_3"
                    type="text"
                    inputmode="decimal"
                    size="sm"
                    :state="rainFactor3State"
                  />
                  <div class="field-feedback">
                    <span v-if="hasDecimalComma(managementForm.RAIN_FACTOR_3)">Use ponto (.) como separador decimal, não vírgula.</span>
                    <span v-else-if="rainFactor3State === false">Obrigatório: valor entre 0 e 100.</span>
                  </div>
                </template>

              </template>

              <!-- Seção: Observações -->
              <div class="group-inputs-title">Observações:</div>
              <b-form-textarea
                id="textarea"
                v-model="form.NOTE"
                placeholder="Observações..."
                maxlength="65553"
                rows="5"
                size="sm"
              ></b-form-textarea>
              <p class="count-notes-chars">
                {{ form.NOTE ? form.NOTE.length : 0 }}/65535
              </p>
            </div>

            <div class="col-xs-12">
              <!-- Seção: Equipamentos -->
              <div class="group-inputs-title">Equipamentos:</div>
              <b-btn
                block
                size="sm"
                squared
                @click="
                  openModal('PickEquipmentsModal', {
                    elementsType: 'valves',
                    typeName: 'Válvulas',
                    selectType: 'selectCheckBox',
                    items: valves,
                    selected: selected.valves,
                  })
                "
                variant="orange"
                >Adicionar ou remover Válvulas ({{ selected.valves.length }}/{{
                  valves.length
                }})</b-btn
              >
              <div class="selected-box">
                <div
                  class="selected-item"
                  v-for="(sel, index) in selected.valves"
                  :key="index"
                >
                  {{ sel.NAME }}
                </div>
              </div>
              <b-alert
                v-for="(item, index) in valveSelectionInputFeedback"
                :key="index"
                variant="warning"
                show
                class="py-2 px-3 mb-2"
              >
                A válvula <strong>{{ item.valve }}</strong> já está associada
                aos seguintes setores: {{ item.sectors }}
              </b-alert>

              <b-btn
                block
                size="sm"
                squared
                @click="
                  openModal('PickEquipmentsModal', {
                    elementsType: 'hydros',
                    typeName: 'Hidrômetros',
                    selectType: 'selectCheckBox',
                    items: hydros,
                    selected: selected.hydros,
                  })
                "
                variant="orange"
                >Adicionar ou remover Hidrômetros ({{
                  selected.hydros.length
                }}/{{ hydros.length }})</b-btn
              >
              <div class="selected-box">
                <div
                  class="selected-item"
                  v-for="(sel, index) in selected.hydros"
                  :key="index"
                >
                  {{ sel.NAME }}
                </div>
              </div>
              <b-btn
                block
                size="sm"
                squared
                @click="
                  openModal('PickEquipmentsModal', {
                    elementsType: 'sensors',
                    typeName: 'Sensores',
                    selectType: 'selectCheckBox',
                    items: sensors,
                    selected: selected.sensors,
                  })
                "
                variant="orange"
                >Adicionar ou remover Sensores ({{ selected.sensors.length }}/{{
                  sensors.length
                }})</b-btn
              >
              <div class="selected-box">
                <div
                  class="selected-item"
                  v-for="(sel, index) in selected.sensors"
                  :key="index"
                >
                  {{ sel.NAME }}
                </div>
              </div>
              <b-alert
                v-if="managementForm.IS_MANAGEMENT && pluviometerCountInSelection > 1"
                variant="warning"
                show
                class="py-2 px-3 mb-2"
              >
                Múltiplos pluviômetros selecionados. O pluviômetro <strong>{{ selectedPluviometer && selectedPluviometer.NAME }}</strong> (primeiro selecionado) será o utilizado para substituir os dados de precipitação da estação meteorológica.
              </b-alert>
              <b-alert
                v-if="managementForm.IS_MANAGEMENT && pluviometerCountInSelection === 1"
                variant="info"
                show
                class="py-2 px-3 mb-2"
              >
                O pluviômetro <strong>{{ selectedPluviometer && selectedPluviometer.NAME }}</strong> substituirá os dados de precipitação da estação meteorológica para este setor de manejo.
              </b-alert>
              <b-btn
                block
                size="sm"
                squared
                @click="
                  openModal('PickEquipmentsModal', {
                    elementsType: 'pumps',
                    typeName: 'Bombas',
                    selectType: 'selectCheckBox',
                    items: pumps,
                    selected: selected.pumps,
                  })
                "
                variant="orange"
                >Adicionar ou remover Bombas ({{ selected.pumps.length }}/{{
                  pumps.length
                }})</b-btn
              >
              <div class="selected-box">
                <div
                  class="selected-item"
                  v-for="(sel, index) in selected.pumps"
                  :key="index"
                >
                  {{ sel.NAME }}
                </div>
              </div>
            </div>
          </b-form>
        </div>
        <b-modal
          ref="alertValves"
          no-close-on-backdrop
          centered
          hide-footer
          body-bg-variant="light"
          title="Atenção!"
        >
          <div class="modal-form row pb-3">
            <div class="col-xs-12 center-xs">
              <alert-icon title="" style="font-size: 3em; color: #ffc107" />
            </div>
            <div class="col-xs-12 error-title">
              A válvula escolhida possui registros de volumes divergentes da
              válvula anterior, ao realizar a troca irá apagar os dados antigos
              já salvos atrelados a válvula e com isso novos dados de volumes
              serão calculados.
            </div>
          </div>
          <b-btn
            v-if="$refs.alertValves"
            block
            variant="secondary"
            size="sm"
            @click="ignoreAlertsFromValve"
          >
            Estou ciente
          </b-btn>
        </b-modal>

        <b-modal
          ref="formError"
          no-close-on-backdrop
          centered
          hide-footer
          body-bg-variant="light"
          title="Atenção!"
        >
          <div class="modal-form row pb-3">
            <div class="col-xs-12 center-xs">
              <alert-icon title="" style="font-size: 3em; color: #ffc107" />
            </div>
            <div class="col-xs-12 error-title">
              Não é possível realizar a busca de dados porque:
            </div>

            <div class="col-xs-12 error-description">
              <ul>
                <li v-for="err in errors" :key="err">{{ err }}</li>
              </ul>
            </div>
          </div>
          <b-btn
            v-if="$refs.formError"
            block
            variant="secondary"
            size="sm"
            @click="$refs.formError.hide"
          >
            Irei corrigir
          </b-btn>
        </b-modal>
        <!-- MODAL COM EQUIPAMENTOS -->
        <component
          :is="modalName"
          v-if="showEquipmentsModal"
          v-model="showEquipmentsModal"
          :elementsType="modalElements.elementsType"
          :typeName="modalElements.typeName"
          :equipments="modalElements.items"
          :selectType="modalElements.selectType"
          :selected="modalElements.selected"
          @selected="setSelected"
        />
        <footer id="footer" class="pb-2 d-flex">
          <b-btn
            size="sm"
            @click="
              () => {
                resetForm();
                $emit('close-form');
              }
            "
            variant="outline-secondary"
            class="ml-1 mr-2 w-100"
          >
            Cancelar
          </b-btn>
          <b-btn
            variant="3v3"
            size="sm"
            @click="checkForm"
            class="ml-1 mr-2 w-100"
          >
            Salvar
          </b-btn>
        </footer>
        <b-modal
          centered
          ref="dialogWait"
          no-close-on-backdrop
          no-close-on-esc
          size="sm"
          hide-header
          hide-footer
        >
          <div class="center-xs">
            <spinner />
          </div>
          <div class="center-xs pt-3" v-if="currentLoadingMessage">
            {{ currentLoadingMessage }}
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import {
  hydros,
  management,
  monit,
  pumps,
  sectors,
  sensors,
  valves,
} from "@/api";
import { checkIfFarmDapExists } from "@/api/modules/farms_dap/useCases/checkIfExistsFarmDap";
import { managementSectorUseCases } from "@/api/modules/sector/useCases";
import PickEquipmentsModal from "@/common/components/PickEquipmentsModal.vue";
import SearchableSelect from "@/pages/components/shared/SearchableSelect.vue";
import managementSectorsActions from "@/mixins/managementSectorActions.js";
import { cookies } from "@/pages/components/cookies";
import { notRepeatedName } from "@/pages/components/regist/form-functions";
import store from "@/store";
import moment from "moment";
import { farmUseCase } from "../../../../api/modules/farm/useCases";
import { getFarmDapByFarmAndDAPUseCase } from "../../../../api/modules/farms_dap/useCases/getByFarmAndDap";
import { getFarmDapByLastRecordUseCase } from "../../../../api/modules/farms_dap/useCases/getLastRecordFromFarmDAP";
import { soilUseCase } from "../../../../api/modules/soil/useCases";
import { showLasRecord } from "../../../../api/modules/valve/useCases/showLastLog";
import { fixFloatValue } from "../../../components/helpers";
export default {
  name: "sector-form",
  components: { PickEquipmentsModal, SearchableSelect },
  props: {
    // showForm: Boolean,
    formType: String,
    alreadyUsedNames: Array,

    //  hydros: Array,
    //  pumps: Array,
    //  valves: Array,
    //  sensors: Array,
    items: {
      required: false,
      default: () => [],
    },
    itemToEdit: [Number, Object],
  },
  mixins: [managementSectorsActions],
  async created() {
    if (this.hasAccess) {
      await this.loadFarms();
      await this.loadSoils();
    }

    this.hasManagementAcess = JSON.parse(
      localStorage.getItem(`ADD_ONS_ACCESS`)
    ).MANAGEMENT;
    //this.isAdmin = Number(cookies.get("PERMISSION")) == 1
    this.hasAccess = store.getters.isAdmin;
    if (this.formType == "add") {
      this.resetForm();
      this.loadEquipments(this.formType);
    } else {
      this.loadEquipments(this.formType);
      this.form.ID = this.itemToEdit.ID;
      this.form.NAME = this.itemToEdit.NAME;
      this.form.AREA = this.itemToEdit.AREA;
      this.form.PLANTING_TYPE = this.itemToEdit.PLANTING_TYPE;
      this.form.PLANTING_DATE = this.itemToEdit.PLANTING_DATE;
      this.form.NOTE = this.itemToEdit.NOTE;
      if (this.itemToEdit.ID_SOIL) {
        this.managementForm = {
          START_NEW_CYCLE: true,
          OFFSET_DAP: this.itemToEdit.OFFSET_DAP,
          DATE_CROP: this.itemToEdit.DATE_CROP,
          SPACING_BETWEEN_LINES: this.itemToEdit.SPACING_BETWEEN_LINES,
          SPACING_BETWEEN_PLANTS: this.itemToEdit.SPACING_BETWEEN_PLANTS,
          PRESSURIZE_TIME: this.itemToEdit.PRESSURIZE_TIME,
          TIME_ADVANCE: this.itemToEdit.TIME_ADVANCE,
          AVG_TIME_PULSE: this.itemToEdit.AVG_TIME_PULSE,
          APPLICATION_RATE: this.itemToEdit.APPLICATION_RATE,
          SYSTEM_EFFICIENCY: this.itemToEdit.SYSTEM_EFFICIENCY * 100,
          ID_SECTOR: this.itemToEdit.ID,
          ID_SOIL: this.itemToEdit.ID_SOIL,
          ID_FARM: this.itemToEdit.ID_FARM,
          FARM_NAME: this.itemToEdit.FARM_NAME,
          SOIL_NAME: "",
          SECTOR_NAME: this.form.NAME,
          IS_MANAGEMENT: this.itemToEdit.IS_MANAGEMENT,
          INITIAL_STORAGE: this.itemToEdit.INITIAL_STORAGE,
          VOLUME_DATE: this.itemToEdit.VOLUME_DATE,
          RAIN_THRESHOLD_1: this.itemToEdit.RAIN_THRESHOLD_1 || 0,
          RAIN_THRESHOLD_2: this.itemToEdit.RAIN_THRESHOLD_2 || 0,
          RAIN_FACTOR_1: (this.itemToEdit.RAIN_FACTOR_1 ?? 1) * 100,
          RAIN_FACTOR_2: (this.itemToEdit.RAIN_FACTOR_2 ?? 1) * 100,
          RAIN_FACTOR_3: (this.itemToEdit.RAIN_FACTOR_3 ?? 1) * 100,
        };
        const _t1 = this.itemToEdit.RAIN_THRESHOLD_1 || 0;
        const _t2 = this.itemToEdit.RAIN_THRESHOLD_2 || 0;
        this.rainThresholdCount = _t1 > 0 ? (_t2 > _t1 ? 2 : 1) : 0;
        this.getSelectedManagementOptions();
      }
    }

    const stationInfo = await monit.station();

    if (stationInfo && !stationInfo.status) {
      this.hasStation = false;
    }
    this.showForm = true;
  },
  
  data() {
    return {
      showForm: false,
      loading: false,
      currentLoadingMessage: "",
      modalName: "",
      modalElements: {
        elementsType: "",
        typeName: "",
        selectType: "",
        items: [],
        selected: [],
      },
      isLoad: false,
      // equipment: [],
      showEquipmentsModal: false,
      cont: 0,
      isFiltered: false,
      hasManagementAcess: false,
      loadingMessages: {
        actuator: {
          get: "Buscando dados da válvula...",
        },
        sector: {
          create: "Criando setor...",
          update: "Atualizando dados adicionais do setor de manejo...",
        },
        management: {
          calc: "Calculando dados de manejo...",
          create: "Salvando dados calculados de manejo...",
          delete: "Apagando dados de manejo do setor...",
        },
      },
      hasAccess: Boolean,
      valves: [],
      pumps: [],
      sensors: [],
      hydros: [],
      hasStation: true,
      firstEt0Register: null,
      rainThresholdCount: 0,
      form: {
        NAME: "",
        AREA: "",
        PLANTING_TYPE: "",
        PLANTING_DATE: "",
        NOTE: "",
      },
      managementForm: {
        START_NEW_CYCLE: true,
        OFFSET_DAP: 0,
        DATE_CROP: "",
        VOLUME_DATE: "",
        SPACING_BETWEEN_LINES: 0,
        SPACING_BETWEEN_PLANTS: 0,
        PRESSURIZE_TIME: 0,
        TIME_ADVANCE: 0,
        AVG_TIME_PULSE: 0,
        APPLICATION_RATE: 0,
        SYSTEM_EFFICIENCY: 0,
        ID_SECTOR: null,
        ID_SOIL: null,
        ID_FARM: null,
        SOIL_NAME: "",
        FARM_NAME: "",
        SECTOR_NAME: null, //Apenas para salvar novo setor,
        IS_MANAGEMENT: false,
        INITIAL_STORAGE: 0,
        MAX_STORAGE: null,
        RAIN_THRESHOLD_1: 0,
        RAIN_THRESHOLD_2: 0,
        RAIN_FACTOR_1: 100,
        RAIN_FACTOR_2: 100,
        RAIN_FACTOR_3: 100,
      },
      managementSoil: [],
      managementFarms: [],
      managementDaps: [-2, -1, 0, 1, 2],
      equipment: [],
      allSelected: {
        valves: false,
        hydros: false,
        pumps: false,
        sensors: false,
      },
      selected: {
        valves: [],
        hydros: [],
        pumps: [],
        sensors: [],
        farm: {},
        soil: {},
      },
      isFiltered: false,
      filteredElements: [],
      search: "",
      oldValveItem: null, //(Edição)Válvula anterior
      oldManagementInitialDateItem: null, //(Edição) data de início de manejo anterior
      oldPluviometerIdItem: null, //(Edição) ID do pluviômetro anterior
      loadingLogOptions: false,
      controller: null,
      errors: [],
      alertValvesWithDiffTimes: null,
      ignoreAlertFromValves: false,
      hasChangedOnlyNote: false,
      hasChangedDateCrop: false,
    };
  },
  watch: {
    loading(newValue) {
      if (this.isSectorRegister) {
        if (newValue == true) {
          this.$refs.dialogWait.show();
        } else {
          this.$refs.dialogWait.hide();
          this.isSectorRegister = false;
        }
      } else {
        if (newValue) {
          wait.show();
        } else {
          wait.hide();
        }
      }
    },

    "selected.valves": function () {
      this.ignoreAlertFromValves = false;
      this.allSelected.valves =
        this.selected.valves.length == this.valves.length;
    },
    "selected.hydros": function () {
      this.allSelected.hydros =
        this.selected.hydros.length == this.hydros.length;
    },
    "selected.pumps": function () {
      this.allSelected.pumps = this.selected.pumps.length == this.pumps.length;
    },
    isManagement: {
      async handler(newVal) {
        if (newVal) {
          this.firstEt0Register = await this.getFirstEt0Day();
        }
      },
    },
    "selected.sensors": function () {
      if (this.selected.sensors.length > 0) {
        this.allSelected.sensors =
          this.selected.sensors.length == this.sensors.length;
      }
    },
    changeManagementDatas: {
      async handler() {
        //console.log("Teste");
        const today = this.managementForm.VOLUME_DATE;
        const diff = moment(today).diff(this.form.PLANTING_DATE, "days");
        // const aux = moment(this.form.PLANTING_DATE).diff(this.form. , "days");

        let DAP = null;
        // Data de hoje superior a data de plantio
        if (diff >= 0) {
          DAP = diff + 1 + Number(this.managementForm.OFFSET_DAP);
        }
        //Data de hoje antes da data de plantio
        else if (diff < 0) {
          DAP = 0;
        }
        // console.log({ DAP });

        if (DAP !== null) {
          let farm_dap = await getFarmDapByFarmAndDAPUseCase().execute(
            this.managementForm.ID_FARM,
            DAP
          );

          if (!farm_dap) {
            //Pegar último registro de FARM_DAP
            farm_dap = await getFarmDapByLastRecordUseCase().execute(
              this.managementForm.ID_FARM
            );
          }
          const soil = await soilUseCase().showSoilByIdUseCase.execute(
            this.managementForm.ID_SOIL
          );

          //   console.log(farm_dap, " ", soil);
          const MAX_STORAGE = fixFloatValue(
            soil.WATER_DISPONIBILITY * farm_dap.DEPTH_ROOT
          );

          // console.log(DAP);
          this.managementForm.MAX_STORAGE = MAX_STORAGE;
        }
      },
    },
  },
  computed: {
    valveSelectionInputFeedback() {
      return this.selected.valves
        .filter((valve) => valve.SECTORS && valve.SECTORS.length > 0)
        .map((valve) => {
          let sectorNames = valve.SECTORS.map((sector) => sector.NAME);

          if (this.formType == "edit") {
            sectorNames = sectorNames.filter((item) => item != this.form.NAME);
          }

          return {
            valve: valve.NAME,
            sectors: sectorNames.join(", "),
          };
        })
        .filter((valve) => valve.sectors.length != 0);
    },
    pluviometerCountInSelection() {
      return this.selected.sensors.filter(
        s => s.NAME_MODEL && s.NAME_MODEL.includes('PLUVIOMETRO')
      ).length;
    },
    selectedPluviometer() {
      return this.selected.sensors.find(
        s => s.NAME_MODEL && s.NAME_MODEL.includes('PLUVIOMETRO')
      ) || null;
    },
    oldName() {
      return this.itemToEdit && this.itemToEdit.NAME;
    },
    changeManagementDatas() {
      const {
        managementForm: {
          OFFSET_DAP,
          ID_FARM,
          ID_SOIL,
          DATE_CROP,
          VOLUME_DATE,
          INITIAL_STORAGE,
        },
        form: { PLANTING_DATE },
      } = this;
      if (
        PLANTING_DATE &&
        OFFSET_DAP >= 0 &&
        ID_FARM >= 0 &&
        ID_SOIL >= 0 //&&
        // DATE_CROP
      ) {
        return {
          PLANTING_DATE,
          OFFSET_DAP,
          ID_FARM,
          ID_SOIL,
          DATE_CROP,
          VOLUME_DATE,
          INITIAL_STORAGE,
        };
      }
    },
    isManagement() {
      return this.managementForm && this.managementForm.IS_MANAGEMENT;
    },
    validManagementDate() {
      if (!this.managementForm.IS_MANAGEMENT) return null;
      if (!this.managementForm.VOLUME_DATE || this.managementForm.VOLUME_DATE === "") return false;
      return this.convertDateStringToDate(this.managementForm.VOLUME_DATE).getFullYear() > 2000
        ? true
        : false;
    },
    isValidStationStart() {
      if (this.hasStation) {
        return true;
      } else if (!this.managementForm.VOLUME_DATE || !this.firstEt0Register) {
        return false;
      } else if (
        !moment(this.managementForm.VOLUME_DATE).isBefore(this.firstEt0Register)
      ) {
        return true;
      } else {
        return false;
      }
    },
    // selectedItem() {
    //   return this.selected[this.equipment.type];
    // },
    eqps() {
      if (this.isFiltered) {
        return this.filteredElements;
      }
      return this.tableList;
    },
    tableList() {
      return this.equipment;
    },
    notRepeatedName() {
      return notRepeatedName(
        this.alreadyUsedNames,
        this.form.NAME,
        this.formType,
        this.oldName
      );
    },
    nameState() {
      return !!this.form.NAME;
    },
    areaState() {
      let regex = /^[0-9.]*$/;
      let value = this.form.AREA;
      if (value) {
        return regex.test(value);
      }
      if (this.managementForm.IS_MANAGEMENT && !value) {
        return false;
      }
      return true;
    },
    farmState() {
      if (this.managementForm.IS_MANAGEMENT && !this.managementForm.ID_FARM) {
        return false;
      }
      return true;
    },
    soilState() {
      if (this.managementForm.IS_MANAGEMENT && !this.managementForm.ID_SOIL) {
        return false;
      }
      return true;
    },
    spaceBetweensPlantsState() {
      if (this.hasDecimalComma(this.managementForm.SPACING_BETWEEN_PLANTS)) return false;
      let value = Number(this.managementForm.SPACING_BETWEEN_PLANTS);
      if (this.managementForm.IS_MANAGEMENT && value > 0) {
        return true;
      }
      return false;
    },
    spaceBetweensLinesState() {
      if (this.hasDecimalComma(this.managementForm.SPACING_BETWEEN_LINES)) return false;
      if (
        this.managementForm.IS_MANAGEMENT &&
        Number(this.managementForm.SPACING_BETWEEN_LINES) > 0
      ) {
        return true;
      }
      return false;
    },
    pressurizeTimeState() {
      if (
        this.managementForm.IS_MANAGEMENT &&
        Number(this.managementForm.PRESSURIZE_TIME) > 0
      ) {
        return true;
      }
      return false;
    },
    timeAdvanceState() {
      if (
        this.managementForm.IS_MANAGEMENT &&
        Number(this.managementForm.TIME_ADVANCE) > 0
      ) {
        return true;
      }
      return false;
    },
    avgTimePulseState() {
      if (
        this.managementForm.IS_MANAGEMENT &&
        Number(this.managementForm.AVG_TIME_PULSE) > 0
      ) {
        return true;
      }
      return false;
    },
    applicationRateState() {
      if (this.hasDecimalComma(this.managementForm.APPLICATION_RATE)) return false;
      if (
        this.managementForm.IS_MANAGEMENT &&
        Number(this.managementForm.APPLICATION_RATE) > 0
      ) {
        return true;
      }
      return false;
    },
    rainThreshold1State() {
      if (this.rainThresholdCount < 1) return null;
      const t1 = Number(this.managementForm.RAIN_THRESHOLD_1);
      return t1 > 0 ? null : false;
    },
    rainThreshold2State() {
      if (this.rainThresholdCount < 2) return null;
      const t1 = Number(this.managementForm.RAIN_THRESHOLD_1);
      const t2 = Number(this.managementForm.RAIN_THRESHOLD_2);
      return t2 > t1 ? null : false;
    },
    rainFactor1State() {
      if (this.hasDecimalComma(this.managementForm.RAIN_FACTOR_1)) return false;
      const raw = this.managementForm.RAIN_FACTOR_1;
      if (raw === '' || raw === null || raw === undefined) return false;
      const v = Number(raw);
      return v >= 0 && v <= 100 ? true : false;
    },
    rainFactor2State() {
      if (this.rainThresholdCount < 2) return null;
      if (this.hasDecimalComma(this.managementForm.RAIN_FACTOR_2)) return false;
      const raw = this.managementForm.RAIN_FACTOR_2;
      if (raw === '' || raw === null || raw === undefined) return false;
      const v = Number(raw);
      return v >= 0 && v <= 100 ? true : false;
    },
    rainFactor3State() {
      if (this.rainThresholdCount < 1) return null;
      if (this.hasDecimalComma(this.managementForm.RAIN_FACTOR_3)) return false;
      const raw = this.managementForm.RAIN_FACTOR_3;
      if (raw === '' || raw === null || raw === undefined) return false;
      const v = Number(raw);
      return v >= 0 && v <= 100 ? true : false;
    },
    systemEfficiencyState() {
      if (this.hasDecimalComma(this.managementForm.SYSTEM_EFFICIENCY)) return false;
      if (
        this.managementForm.IS_MANAGEMENT &&
        Number(this.managementForm.SYSTEM_EFFICIENCY) >= 1 &&
        Number(this.managementForm.SYSTEM_EFFICIENCY) <= 100
      ) {
        return true;
      }
      return false;
    },
    initialStorageState() {
      if (this.hasDecimalComma(this.managementForm.INITIAL_STORAGE)) return false;
      const v = this.managementForm.INITIAL_STORAGE;
      if (
        this.form.PLANTING_DATE &&
        this.managementForm.MAX_STORAGE >= 0 &&
        v !== '' && v !== null &&
        Number(v) > this.managementForm.MAX_STORAGE
      ) {
        return false;
      }
      return null;
    },
    offSetDapState() {
      if (
        this.managementForm.IS_MANAGEMENT &&
        this.managementForm.OFFSET_DAP !== null
      ) {
        return true;
      }
      return false;
    },
    dateCropState() {
      if (this.managementForm.IS_MANAGEMENT) {
        if (!this.form.PLANTING_DATE && this.managementForm.DATE_CROP) {
          return false;
        }
        if (this.managementForm.DATE_CROP) {
          if (this.managementForm.VOLUME_DATE) {
            return moment(this.managementForm.DATE_CROP).isAfter(
              moment(this.managementForm.VOLUME_DATE)
            );
          }
          let diff = moment(this.managementForm.DATE_CROP).diff(
            moment(this.form.PLANTING_DATE),
            "days"
          );
          if (diff > 0) {
            return true;
          }

          return false;
        }
      }

      return true;
    },
    managementInitialDateState() {
      if (this.managementForm.VOLUME_DATE) {
        const today = moment().format("YYYY-MM-DD");
        return this.managementForm.VOLUME_DATE < today;
      } else return true;
    },
    plantingDateState() {
      if (this.managementForm.IS_MANAGEMENT) {
        if (!this.form.PLANTING_DATE) {
          return false;
        }

        return (
          this.convertDateStringToDate(this.form.PLANTING_DATE).getFullYear() >
          2000
        );
      }
      return true;
    },
    dateCropInputState() {
      if (this.managementForm.IS_MANAGEMENT && !this.managementForm.DATE_CROP) {
        return (
          this.convertDateStringToDate(
            this.managementForm.DATE_CROP
          ).getFullYear() > 2000
        );
      }

      return true;
    },
  },
  methods: {
    openModal(
      modalName,
      { elementsType, typeName, selectType, items, selected }
    ) {
      this.modalName = modalName;
      if (selectType == "selectRadio" && selected) {
        selected = selected[0];
      }
      this.modalElements = {
        elementsType,
        typeName,
        selectType,
        items,
        selected,
      };
      if (this.isLoad) {
        this.showEquipmentsModal = true;
      }
    },
    setSelected(selected, type) {
      this.selected[type] = selected;
      /*if (type == "soil") {
        this.managementForm.ID_SOIL = this.selected[type].ID;
        this.managementForm.SOIL_NAME = this.selected[type].NAME;
      }
      if (type == "farm") {
        this.managementForm.ID_FARM = this.selected[type].ID;
        this.managementForm.FARM_NAME = this.selected[type].NAME;
      }*/
    },
    onFarmSelect(id) {
      const farm = this.managementFarms.find(f => f.ID === id);
      if (farm) {
        this.managementForm.FARM_NAME = farm.NAME;
        this.selected.farm = farm;
      }
    },
    onSoilSelect(id) {
      const soil = this.managementSoil.find(s => s.ID === id);
      if (soil) {
        this.managementForm.SOIL_NAME = soil.NAME;
        this.selected.soil = soil;
      }
    },
    hasDecimalComma(value) {
      return String(value).includes(",");
    },
    getSelectedManagementOptions() {
      const getterSelectedSoil = this.managementSoil.filter(
        (soil) => soil.ID == this.managementForm.ID_SOIL
      );
      const getterSelectedFarm = this.managementFarms.filter(
        (farm) => farm.ID == this.managementForm.ID_FARM
      );
      this.selected.soil = getterSelectedSoil[0];
      this.selected.farm = getterSelectedFarm[0];
      this.managementForm.SOIL_NAME = this.selected.soil.NAME;
    },

    async onSubmitForm(SECTOR_PROPS) {
      let shouldReload = true;
      try {
        // console.log("SECTORPORPS", SECTOR_PROPS);
        const hasManagementProps = Reflect.has(SECTOR_PROPS, "MANAGEMENT");
        const isManagementSector = hasManagementProps
          ? SECTOR_PROPS.MANAGEMENT.IS_MANAGEMENT
          : null;

        this.isSectorRegister = true;
        this.loading = true;
        this.currentLoadingMessage = "Aguarde...";

        const ret = await sectors[this.formType](SECTOR_PROPS.SECTOR);

        if (ret.alert !== "s") {
          if (ret.log && ret.log.includes("Duplicate entry")) {
            this.errors = [
              `Já existe um setor com o nome "${this.form.NAME}". Por favor, escolha um nome diferente.`,
            ];
            this.$refs.formError.show();
            shouldReload = false;
            return;
          }
          alert(ret.log, ret.alert);
          throw new Error(`Falha ao cadastrar dados do setor - ${ret.log}`);
        }

        alert(ret.log, ret.alert);

        if (!SECTOR_PROPS.HAS_CHANGED_ONLY_NOTE && this.hasManagementAcess) {
          if (hasManagementProps && isManagementSector) {
            this.currentLoadingMessage = this.loadingMessages.actuator.get;
            this.currentValves = await this.getValveInfo(SECTOR_PROPS);

            const hasFarmDap = await checkIfFarmDapExists.execute(
              SECTOR_PROPS.MANAGEMENT.ID_FARM
            );

            if (!hasFarmDap) {
              throw "Não existe dados de DAP do cultivar, não irá ser possível calcular o manejo!";
            }

            // Flags de invalidação de alegados por mudança de fonte (só no edit): troca de válvula
            // → zera volume alegado; troca de pluviômetro → zera chuva alegada. O backend aplica no
            // recalc; nos demais casos os alegados são preservados pelo upsert do recompute.
            let resetFlags = {};
            if (this.formType === "add") {
              SECTOR_PROPS.MANAGEMENT.ID_SECTOR = ret.value;

              this.currentLoadingMessage = this.loadingMessages.sector.create;
              await managementSectorUseCases()[this.formType].execute(
                SECTOR_PROPS.MANAGEMENT
              );

              await this.saveOffSetDap(SECTOR_PROPS);
            } else if (this.formType === "edit") {
              this.currentLoadingMessage = this.loadingMessages.sector.update;
              resetFlags = (await this.updateSectorHandler(SECTOR_PROPS)) || {};
            }

            const finalSectorId = SECTOR_PROPS.MANAGEMENT.ID_SECTOR || SECTOR_PROPS.SECTOR.ID;
            this.currentLoadingMessage = this.loadingMessages.management.calc;
            await management.recalc({ sectorIds: [finalSectorId], ...resetFlags });
          } else {
            const sectorId =
              SECTOR_PROPS.SECTOR.ID || SECTOR_PROPS.MANAGEMENT.ID_SECTOR;

            if (sectorId) {
              if (SECTOR_PROPS.MANAGEMENT.ID_SECTOR != null) {
                this.currentLoadingMessage =
                  this.loadingMessages.management.delete;
              }
              await this.deleteManagementDatasFromSector(sectorId);
            }
          }
        }

        const ID_USER = cookies.get("ID");

        if (this.hasManagementAcess) {
          await managementSectorUseCases().updateFkEditor.execute(
            SECTOR_PROPS.SECTOR.ID || SECTOR_PROPS.MANAGEMENT.ID_SECTOR,
            ID_USER
          );
        }
      } catch (error) {
        console.error(error);
        alert(
          `Ocorreu um erro ao ${
            this.formType === "add" ? "adicionar" : "editar"
          } setor. Erro: ${error}`,
          "e"
        );
      } finally {
        if (shouldReload) this.reload();
        this.recalcUntilDateCrop = false;
        this.loading = false;
      }
    },

    reload() {
      this.$emit("get-data-again");
      this.$emit("close-form");
    },
    async loadEquipments(type) {
      this.isLoad = false;
      try {
        const hydrosPromise = sectors.hydros();
        const pumpsPromise = sectors.pumps();
        const valvesPromise = sectors.valves();
        const sensorsPromise = sectors.sensors();

        const [hydrosResponse, pumpsResponse, valvesResponse, sensorsResponse] =
          await Promise.allSettled([
            hydrosPromise,
            pumpsPromise,
            valvesPromise,
            sensorsPromise,
          ]);

        this.hydros = hydrosResponse.value;
        this.pumps = pumpsResponse.value;
        this.valves = valvesResponse.value;
        this.sensors = sensorsResponse.value;

        if (type !== "add") {
          const hydroIDs = this.itemToEdit.hydros.map((se) => se.ID_HYDRO);
          if (hydroIDs[0] !== null) {
            this.selected.hydros = this.hydros.filter((e) =>
              hydroIDs.includes(e.ID)
            );
          }

          const pumpIDs = this.itemToEdit.pumps.map((se) => se.ID_PUMP);
          if (pumpIDs[0] !== null) {
            this.selected.pumps = this.pumps.filter((e) =>
              pumpIDs.includes(e.ID)
            );
          }

          const valveIDs = this.itemToEdit.valves.map((se) => se.ID_VALVE);
          if (valveIDs[0] !== null) {
            this.selected.valves = this.valves.filter((e) =>
              valveIDs.includes(e.ID)
            );
          }
          // Snapshot da válvula original, capturado após o populate (como o pluviômetro).
          this.oldValveItem = [...this.selected.valves];

          const sensorIDs = this.itemToEdit.sensors.map((se) => se.ID_SENSOR);
          if (sensorIDs[0] !== null) {
            this.selected.sensors = this.sensors.filter((e) =>
              sensorIDs.includes(e.ID)
            );
          }

          const oldPluviometer = this.selected.sensors.find(
            s => s.NAME_MODEL && s.NAME_MODEL.includes('PLUVIOMETRO')
          );
          this.oldPluviometerIdItem = oldPluviometer ? oldPluviometer.ID : null;
        }
      } catch (err) {
        console.error(err);
        alert("Erro ao buscar equipamentos para formulário.");
      } finally {
        this.isLoad = true;
      }
    },
    moment,
    async incrementCycleCount({ idSector }) {
      try {
        await management.incrementManagementCycle({ idSector });
        alert("Sucesso ao salvar histórico do ciclo antes da alteração", "s");
      } catch (e) {
        alert(
          "Ocorreu um erro ao salvar histórico do ciclo antes da alteração",
          "e"
        );
      }
    },
    async getFirstEt0Day() {
      const first_et0_day = await management
        .getFirstEt0Date()
        .catch((err) => {
          console.log(err);
          return {};
        });

      return first_et0_day && first_et0_day.TIME;
    },
    managementVolumeDateFormatter(date) {
      let yesterday = moment().subtract(1, "day").format("YYYY-MM-DD");
      if (date >= yesterday) {
        return yesterday;
      }
      return date;
    },
    isMobile(ref) {
      return isMobile(ref);
    },
    async loadSoils() {
      const data = await soilUseCase().show.execute();
      const [soils] = data;
      if (soils) {
        this.managementSoil = soils
          .map(soil => ({ ID: soil.ID, NAME: soil.NAME }))
          .sort((a, b) => a.NAME.localeCompare(b.NAME));
      }
    },
    async loadFarms() {
      const data = await farmUseCase().show.execute();
      const [farms] = data;
      if (farms) {
        this.managementFarms = farms
          .map(farm => ({ ID: farm.ID, NAME: farm.NAME }))
          .sort((a, b) => a.NAME.localeCompare(b.NAME));
      }
    },
    resetForm() {
      this.form = {
        NAME: "",
        AREA: "",
        PLANTING_TYPE: "",
        PLANTING_DATE: "",
        NOTE: "",
      };

      this.equipment = [];
      this.allSelected = {
        valves: false,
        hydros: false,
        pumps: false,
        sensors: false,
      };
      this.selected = {
        valves: [],
        hydros: [],
        pumps: [],
        sensors: [],
      };
      this.managementForm = {
        OFFSET_DAP: 0,
        DATE_CROP: "",
        VOLUME_DATE: "",
        SPACING_BETWEEN_LINES: 0,
        SPACING_BETWEEN_PLANTS: 0,
        PRESSURIZE_TIME: 0,
        TIME_ADVANCE: 0,
        AVG_TIME_PULSE: 0,
        APPLICATION_RATE: 0,
        SYSTEM_EFFICIENCY: 0,
        INITIAL_STORAGE: 0,
        ID_SECTOR: null,
        ID_SOIL: null,
        ID_FARM: null,
        SOIL_NAME: "",
        FARM_NAME: "",
        SECTOR_NAME: null, //Apenas para salvar novo setor
        IS_MANAGEMENT: false,
        MAX_STORAGE: null,
        RAIN_THRESHOLD_1: 0,
        RAIN_THRESHOLD_2: 0,
        RAIN_FACTOR_1: 100,
        RAIN_FACTOR_2: 100,
        RAIN_FACTOR_3: 100,
      };
      this.rainThresholdCount = 0;
    },
    addRainThreshold() {
      if (this.rainThresholdCount < 2) this.rainThresholdCount++;
    },
    removeRainThreshold(index) {
      if (index === 2) {
        this.managementForm.RAIN_THRESHOLD_2 = 0;
        this.managementForm.RAIN_FACTOR_2 = 100;
        this.rainThresholdCount = 1;
      } else {
        this.managementForm.RAIN_THRESHOLD_1 = 0;
        this.managementForm.RAIN_THRESHOLD_2 = 0;
        this.managementForm.RAIN_FACTOR_2 = 100;
        this.managementForm.RAIN_FACTOR_3 = 100;
        this.rainThresholdCount = 0;
      }
    },
    ignoreAlertsFromValve() {
      this.ignoreAlertFromValves = true;
      this.$refs.alertValves.hide();
    },
    async checkLogsFromValves() {
      const { oldValves, valves } = this.form;
      //Não tiver válvula anterior atrelado ao setor antes ou clicar em editar e não trocar a válvula
      if (!oldValves || !oldValves.length) {
        return false;
      }

      const volumeValve = (valves, name) => valves.find(v => v.NAME === name) || valves[0];

      const valve_name = volumeValve(valves, this.form.NAME).NAME;
      const old_valve_name = volumeValve(oldValves, this.form.NAME).NAME;

      // const valve_name = valves[0].NAME;
      // const old_valve_name = oldValves[0].NAME;

      // Primeiro registro da válvula no LOG_ACTUATOR
      // first_record_from_valve=[{TIME:"YYYY-MM-DD HH:mm:ss"}]
      const first_record_from_valve = await showLasRecord.execute(valve_name);
      //Se não tiver registro da válvula nova e nem tiver detectado a válvula antiga

      const first_record_from_last_valve = await showLasRecord.execute(
        old_valve_name
      );

      // Caso não tiver nenhum primeiro registro das válvulas no LOG_ACTUAOTR
      if (!first_record_from_last_valve && !first_record_from_valve) {
        return false;
      }

      if (
        (first_record_from_last_valve &&
          first_record_from_last_valve.length &&
          !first_record_from_valve) ||
        (!first_record_from_last_valve &&
          first_record_from_valve &&
          first_record_from_valve.length)
      ) {
        return true;
      }
      let first_valve_time = moment(first_record_from_valve[0].TIME);
      let last_valve_time = moment(first_record_from_last_valve[0].TIME);
      let diff = first_valve_time.diff(last_valve_time, "day");

      if (Math.abs(diff) > 0) {
        // Aviso
        // this.$refs.registerValvesSectorDialog.show();
        return true;
      }
      //Se não tiver encontrado a válvula anterior
    },
    checkIfPropsHasChanged() {
      const oldForm = {
        ID: this.itemToEdit.ID,
        NAME: this.itemToEdit.NAME,
        AREA: this.itemToEdit.AREA,
        PLANTING_TYPE: this.itemToEdit.PLANTING_TYPE,
        PLANTING_DATE: this.itemToEdit.PLANTING_DATE,
        NOTE: this.itemToEdit.NOTE,
        OFFSET_DAP: this.itemToEdit.OFFSET_DAP,
        DATE_CROP: this.itemToEdit.DATE_CROP,
        SPACING_BETWEEN_LINES: this.itemToEdit.SPACING_BETWEEN_LINES,
        SPACING_BETWEEN_PLANTS: this.itemToEdit.SPACING_BETWEEN_PLANTS,
        PRESSURIZE_TIME: this.itemToEdit.PRESSURIZE_TIME,
        TIME_ADVANCE: this.itemToEdit.TIME_ADVANCE,
        AVG_TIME_PULSE: this.itemToEdit.AVG_TIME_PULSE,
        APPLICATION_RATE: this.itemToEdit.APPLICATION_RATE,
        SYSTEM_EFFICIENCY: this.itemToEdit.SYSTEM_EFFICIENCY,
        ID_SECTOR: this.itemToEdit.ID,
        ID_SOIL: this.itemToEdit.ID_SOIL,
        ID_FARM: this.itemToEdit.ID_FARM,
        SECTOR_NAME: this.form.NAME,
        IS_MANAGEMENT: this.itemToEdit.IS_MANAGEMENT,
        INITIAL_STORAGE: this.itemToEdit.INITIAL_STORAGE,
        VOLUME_DATE: this.itemToEdit.VOLUME_DATE,
      };

      const newForm = {
        ...this.managementForm,
        ...{
          ID: this.form.ID,
          NAME: this.form.NAME,
          AREA: this.form.AREA,
          PLANTING_TYPE: this.form.PLANTING_TYPE,
          PLANTING_DATE: this.form.PLANTING_DATE,
          NOTE: this.form.NOTE,
        },
      };

      Reflect.deleteProperty(newForm, "MAX_STORAGE");

      const result = [];

      for (const [key, value] of Object.entries(newForm)) {
        if (value !== oldForm[key]) {
          result.push(key);
        }
      }

      this.hasChangedOnlyNote = result.length
        ? result.every((value) => value === "NOTE")
        : false;

      const hasChangedDateCrop = result.length
        ? result.some((value) => value === "DATE_CROP")
        : false;
      this.hasChangedDateCrop = hasChangedDateCrop;
    },
    convertDateStringToDate(dateString, separator = "-") {
      const [year, month, day] = dateString.split(separator);
      return new Date(year, month - 1, day);
    },
    async checkForm() {
      this.errors = [];
      for (let key of Object.keys(this.form)) {
        if (this.form[key] == "") this.form[key] = null;
      }

      let states = [this.nameState, this.notRepeatedName, this.areaState];
      let erros = [
        "Nome é obrigatório.",
        "O nome escolhido já está em uso.",
        "Use ponto no lugar de vírgula para indicar valores decimais.",
      ];

      if (this.managementForm.IS_MANAGEMENT) {
        states = [
          ...states,
          this.farmState,
          this.soilState,
          this.spaceBetweensPlantsState,
          this.spaceBetweensLinesState,
          this.systemEfficiencyState,
          this.offSetDapState,
          this.plantingDateState,
          this.validManagementDate,
        ];

        erros = [
          ...erros,
          "É necessário informar o cultivar",
          "É necessário informar o solo",
          "É necessário informar o espaçamento entre plantas",
          "É necessário informar o espaçamento entre linhas",
          // "É necessário informar o tempo de Pressurização ",
          // "É necessário informar o tempo de avanço",
          // "É necessário informar o tempo médio de pulso",
          "É necessário informar a eficiência do sistema",
          "É necessário informar a offset DAP",
          "É necessário informar a data de plantio",
          "É necessário informar uma data inicial de manejo válida",
        ];

        states.map((e, i) => {
          if (!e) this.errors.push(erros[i]);
        });

        // Quando múltiplas válvulas, e manejo, exatamente uma deve ter nome igual ao setor
        if (this.selected.valves.length > 1) {
          const hasMatchingValve = this.selected.valves.some(
            v => v.NAME === this.form.NAME
          );
          if (!hasMatchingValve) {
            this.errors.push(
              "Com múltiplas válvulas, uma delas deve ter o mesmo nome do setor"
            );
          }
        }

        if (!this.selected.valves.length) {
          this.errors.push("É necessário ter uma válvula para setor de manejo");
        }

        if (this.initialStorageState === false) {
          this.errors.push(`O armazenamento inicial não pode ser maior que o máximo (${this.managementForm.MAX_STORAGE} mm)`);
        }

        if (this.dateCropState === false) {
          this.errors.push("A data de colheita deve ser superior à data de plantio e à data inicial de manejo");
        }

        if (this.rainThreshold1State === false) {
          this.errors.push("Limiar 1 de precipitação deve ser maior que 0");
        }
        if (this.rainThreshold2State === false) {
          this.errors.push("Limiar 2 de precipitação deve ser maior que o Limiar 1");
        }
        if (this.rainFactor1State === false) {
          this.errors.push("Fator 1 de precipitação deve ser entre 0 e 100");
        }
        if (this.rainFactor2State === false) {
          this.errors.push("Fator 2 de precipitação deve ser entre 0 e 100");
        }
        if (this.rainFactor3State === false) {
          this.errors.push("Fator 3 de precipitação deve ser entre 0 e 100");
        }

        // if (!this.validManagementDate && this.firstEt0Register) {
        //   this.errors.push(
        //     `Só é possível criar manejo a partir do dia: ${moment(
        //       this.firstEt0Register
        //     ).format("DD/MM/YYYY")}`
        //   );
        // }
        // else if (!this.validManagementDate && !this.firstEt0Register) {
        //   this.errors.push(
        //     "Não existem dados de ET0 e precipitação registrados ainda, cadastre-os antes de registrar o setor."
        //   );
        // }
      } else {
        states.map((e, i) => {
          if (!e) this.errors.push(erros[i]);
        });
      }

      this.form.valves = this.selected.valves;
      this.form.hydros = this.selected.hydros;
      this.form.sensors = this.selected.sensors;
      this.form.pumps = this.selected.pumps;

      if (this.formType == "edit" && this.managementForm.IS_MANAGEMENT) {
        this.managementForm.SECTOR_NAME = this.form.NAME;
        //Data de manejo anterior
        //Caso for detectado alguma modificação na data, então coloca a mais recente
        this.form.oldManagementInitialDate =
          this.oldManagementInitialDateItem !== this.managementForm.VOLUME_DATE
            ? this.managementForm.VOLUME_DATE
            : null;
        //Válvula anterior - só para caso de edição
        //  console.log(this.oldValveItem)

        const volumeValveId = (valves, sectorName) => (valves.find(v => v.NAME === sectorName) || 
                                                        valves[0])?.ID;

        //Verifica que não houve mudança de válvula 
        this.form.oldValves =
          volumeValveId(this.oldValveItem, this.form.NAME) !==
          volumeValveId(this.form.valves, this.form.NAME)
            ? this.oldValveItem
            : null;

        this.form.oldPluviometerId = this.oldPluviometerIdItem;

        /*if (this.oldValveItem.length) {
          //Deve receber valor diferente da válvula atual
          this.form.oldValves =
            this.oldValveItem[0].ID !== this.form.valves[0].ID
              ? this.oldValveItem
              : null;
        }*/
        if (!this.ignoreAlertFromValves) {
          this.alertValvesWithDiffTimes = await this.checkLogsFromValves();
        }
        this.checkIfPropsHasChanged();
      }

      if (this.errors.length) this.$refs.formError.show();
      else if (!this.ignoreAlertFromValves && this.alertValvesWithDiffTimes)
        this.$refs.alertValves.show();
      else {
        // this.managementForm.SYSTEM_EFFICIENCY=this.managementForm.SYSTEM_EFFICIENCY/100
        if (this.managementForm.START_NEW_CYCLE && this.form.ID) {
          //console.log('ta adicionando o ciclo antes de tudo')
          await this.incrementCycleCount({ idSector: this.form.ID });
        }
        await this.onSubmitForm({
          SECTOR: this.form,
          MANAGEMENT: {
            ...this.managementForm,
            SYSTEM_EFFICIENCY: this.managementForm.SYSTEM_EFFICIENCY / 100,
            RAIN_FACTOR_1: this.managementForm.RAIN_FACTOR_1 / 100,
            RAIN_FACTOR_2: this.managementForm.RAIN_FACTOR_2 / 100,
            RAIN_FACTOR_3: this.managementForm.RAIN_FACTOR_3 / 100,
          },
          HAS_CHANGED_ONLY_NOTE: this.hasChangedOnlyNote,
          HAS_CHANGED_DATE_CROP: this.hasChangedDateCrop,
        });
      }
    },
    toggleAll(str) {
      this.allSelected[str] = !this.allSelected[str];
      if (this.selected[str].length < this[str].length) {
        this.selected[str] = this[str].slice();
      } else if (this.selected[str].length == this[str].length) {
        this.selected[str] = [];
      }
    },
  },
};
</script>

<style scoped>
.count-notes-chars {
  font-size: 0.8em;
  text-align: end;
  color: var(--text-gray-secondary);
}
.field-feedback {
  min-height: 1.5em;
  line-height: 1.5;
  font-size: 0.8em;
  color: #dc3545;
  margin-bottom: 2px;
}
.equipment-table {
  height: 310px !important;
  overflow-x: hidden;
  overflow-y: auto;
}
.max-storage-feedback {
  font-size: 0.8em;
  /* color: var(--text-gray-secondary); */
}

@media screen and (max-width: 767px) {
  .container {
    padding-bottom: 3em;
  }

  #form .row {
    padding-bottom: 2em;
  }

  #form,
  #details {
    padding-top: 1em;
  }
}
</style>
